import { Tracker } from '@jbhi-fi/components/src/Tracking';
import { Location, Coupon } from '@jbhi-fi/components/src/types';

export const useCouponTracking = (selectedCoupon: Coupon | null) => {
  const trackCouponEvent = ({
    type,
    label,
    location,
    coupon,
    action = 'digital',
    couponStatusInCart,
  }: {
    type: string;
    label?: string;
    location?: Location;
    coupon?: Coupon;
    action?: 'digital' | 'manual';
    couponStatusInCart?: {
      is_valid?: 'valid_coupon' | 'invalid_coupon';
      form_step?: string;
      step_number?: string;
    };
  }) => {
    Tracker.trackCustomEvent({
      event: type,
      coupon_name: selectedCoupon?.content?.displayName || coupon?.couponDescription || '',
      coupon: selectedCoupon?.couponName || coupon?.couponName || '',
      coupon_id: selectedCoupon?.couponExternalId || coupon?.couponExternalId || '',
      type: couponStatusInCart?.is_valid || '',
      ...(couponStatusInCart?.form_step ? { form_step: couponStatusInCart.form_step } : {}),
      ...(couponStatusInCart?.step_number ? { step_number: couponStatusInCart.step_number } : {}),
      ...(action ? { action } : {}),
      ...(location ? { location } : {}),
      ...(label ? { label } : {}),
    });
  };

  return { trackCouponEvent };
};
